

import { classesRuntime, statesRuntime } from "./../../stylable-esm-runtime.js";



var _namespace_ = "wds_1_116_0_SidePanelHeader";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_116_0_SidePanelHeader__root","titleContainer":"wds_1_116_0_SidePanelHeader__titleContainer","title":"wds_1_116_0_SidePanelHeader__title","buttonBox":"wds_1_116_0_SidePanelHeader__buttonBox","helpIcon":"wds_1_116_0_SidePanelHeader__helpIcon","helpButton":"wds_1_116_0_SidePanelHeader__helpButton","closeButton":"wds_1_116_0_SidePanelHeader__closeButton"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-side-panel-header-padding-left":"--wds-side-panel-header-padding-left","wds-side-panel-header-padding-right":"--wds-side-panel-header-padding-right","wds-side-panel-header-padding-vertical":"--wds-side-panel-header-padding-vertical","wds-side-panel-floating-header-padding-left":"--wds-side-panel-floating-header-padding-left","wds-side-panel-floating-header-padding-right":"--wds-side-panel-floating-header-padding-right","wds-side-panel-floating-header-padding-vertical":"--wds-side-panel-floating-header-padding-vertical","wds-space-0":"--wds-space-0","wds-space-50":"--wds-space-50","wds-space-100":"--wds-space-100"}; 




